import Joi from '@hapi/joi';
import { TypologyForm } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<TypologyForm>>({
  productCodes: Joi.array().required().messages({
    'any.required': 'REQUIRED_FIELD',
  }),
  name: Joi.string().required().messages({
    'string.empty': 'REQUIRED_FIELD',
  }),
});

export default function (value: Partial<TypologyForm>) {
  return validate(schema, value, {
    allowUnknown: true,
    context: {},
  });
}
